<template>
  <div
    ref="outerContainerRef"
    class="
      remark-v2
      tw-flex
      tw-flex-col
      tw-gap-2
      tw-px-6
      tw-py-4
      tw-border
      tw-border-solid
      tw-rounded-lg
      tw-group
    "
    :class="[backgroundClasses, dimmedClasses, higlightedClasses]"
    @click.stop="handleClick"
  >
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

interface Props {
  dimmed?: boolean
  highlighted?: boolean
  subtleBackground?: boolean
}

const { dimmed, highlighted, subtleBackground } = defineProps<Props>()

const outerContainerRef = ref<HTMLElement | null>(null)

const emit =
  defineEmits<{
    click: [e: Event]
    clickOutside: [e: Event]
  }>()

const backgroundClasses = computed(() => ({
  'tw-bg-sf-snow-subtle': subtleBackground,
  'tw-bg-sf-snow-lighter': !subtleBackground,
}))

const dimmedClasses = computed(() => ({
  'tw-opacity-50': dimmed,
}))

const higlightedClasses = computed(() => ({
  'tw-border-sf-primary-dark': highlighted,
  'tw-shadow-highlight': highlighted,
  'tw-border-gray-300': !highlighted,
}))

function handleClick(e: Event) {
  emit('click', e)
}

function handleClickOutside(e: Event) {
  if (highlighted) {
    emit('clickOutside', e)
  }
}

onClickOutside(outerContainerRef, handleClickOutside)
</script>
